import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { LanguageProvider } from '../context/LanguageContext';
import { getRouteInfo } from '../seo/config';
import Seo from '../seo/Seo';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import SupportPage from './pages/SupportPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import NotFoundPage from './pages/NotFoundPage';

const PAGES = {
      home: HomePage,
      privacy: PrivacyPage,
      terms: TermsPage,
      support: SupportPage,
      deletion: AccountDeletionPage,
      notFound: NotFoundPage,
};
 
function AppPage() {
      const location = useLocation();
      const { page } = getRouteInfo(location.pathname);
      const Page = PAGES[page] || NotFoundPage;

      return <Page />;
}
 
export function RoutedApp() {
      return (
            <LanguageProvider>
                  <Seo />
                  <AppPage />
            </LanguageProvider>
      );
}

function App() {
      return (
            <BrowserRouter>
                  <RoutedApp />
            </BrowserRouter>
      );
}
 
export default App;
